import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { PropTypes } from 'prop-types';
//import MyEditor from '../MyEditor';
import RedactorEditor from '../RedactorEditor';

import uuid from 'uuid/v4';

import BasicDropDown from '../../../Form/BasicDropDowns/BasicDropDownParagraph';

//import '../../../../static/redactor.css';
//import Redactor from '../../../../static/redactor';

const paragraphOptions = ['creditslayout', 'enhanced', 'paddingLeft', 'firstLetterBig', 'quote', 'none'];

const ParagraphModule = ({
  activeLanguage,
  handlerSetComponents,
  components,
  id,
  reusableComponent,
  reusableComponentSlugname,
  match,
}) => {
  const initialState = {
    type: 'NormalBodyText',
    text: {
      en: '',
    },
    enhanced: false,
    creditslayout: false,
    firstLetterBig: false,
    quote: false,
    paddingLeft: false,
    color: 'black',
  };

  // console.log("loading paragraf", id);
  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [text, setText] = useState(false);
  const [componentDataReceived, setComponentDataReceived] = useState(false);
  const [isZIndexHigh, setZIndexHigh] = useState(true);
  const [categoryFromSection, setCategoryFromSection] = useState('');
  const [currentLanguage, setCurrentLanguage] = useState('');
  const [initializedRedactor, setInitializedRedactor] = useState(false);
  const [updatedText, setUpdatedText] = useState(false);

  useEffect(()=>{
    if(text){
      // console.log("Received", id);
      state.text[activeLanguage] = text;
      setState({ ...state})
      setUpdatedText(uuid());
    }
  }, [text])

  // useEffect(()=>{
  //   console.log("init component", id);
  //   return () => {
  //     console.log("remove component", id);
  //   }
  // },[])
  // useEffect(() => {
  //   const { params: { postCategory = '' } = {} } = match;
  //   const category = postCategory && postCategory !== 'blank' ? postCategory : null;
  //   if (category) setCategoryFromSection(category);
  // }, []);

  useEffect(()=> {
    if(index >= 0){
      // console.log("SAVED STATE", id);
      const constructionObj = {
        type: state.type,
        compId: state.compId || `${state.type}_${id}`,
        ...state
      };

      const componentObj = {
        id,
        component: constructionObj,
      };
      handlerSetComponents(componentObj, index);
    }
  }, [updatedText])

  useEffect(() => {
      const componentIndex = components.findIndex(obj => obj.id === id);
      const { component } = components[componentIndex];
      if (reusableComponent) {
        setState(reusableComponent);
        if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
      } else {
        setIndex(componentIndex);

        if (component) {
          // console.log("Data comes form dataset", id)
          setState(component);
        } else {
          // const componentObj = {
          //   id,
          //   component: state,
          // };
          // console.log("Data is not present", id)
          setText('');
          //handlerSetComponents(componentObj, componentIndex);
        }
      }
  }, [components]);

  const storeOption = (option) => {
    const { component } = components[index];
    let comp = {
      ...component,
      enhanced: false,
      firstLetterBig: false,
      quote: false,
      paddingLeft: false,
      creditslayout: false,
    };
    if (option.toLowerCase() === 'enhanced') {
      comp = {
        ...comp,
        [option.toLowerCase()]: true,
        paddingLeft: true,
      };
      setState(comp);
    } else if (option.toLowerCase() === 'paddingleft') {
      comp = {
        ...comp,
        paddingLeft: true,
      };
      setState(comp);
    } else if (option.toLowerCase() === 'firstletterbig') {
      comp = {
        ...comp,
        firstLetterBig: true,
      };
      setState(comp);
    } else if (option.toLowerCase() === 'creditslayout') {
      comp = {
        ...comp,
        creditslayout: true,
      };
      setState(comp);
    } else if (option.toLowerCase() === 'none') {
      comp = {
        ...comp,
        enhanced: false,
        paddingLeft: false,
        firstLetterBig: false,
        quote: false,
        creditslayout: false,
      };
      setState(comp);
    } else {
      comp = {
        ...comp,
        [option.toLowerCase()]: true,
      };
      setState(comp);
    }

    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };

  // const handleInput = (contentHtml, lang) => {
  //   inputHandler(contentHtml, 'text', lang);
  // };

  // const handleZindexOnMyEditorBlur = (isOnBlur) => {
  //   setZIndexHigh(isOnBlur);
  // };

  return (
    <div className="w-full">
      <div className="w-full py-4">
        <RedactorEditor
          text={state.text[activeLanguage]}
          setText={setText}
          id={id}
        />
      </div>
      <div className="bg-gray200 w-full py-1/2 flex relative rounded">
        <div className={`w-1/3 ml-13 z-${isZIndexHigh ? '5' : '0'}`}>
          <BasicDropDown title="Paragraph Options" message="No options available" suggestions={paragraphOptions} storeOption={storeOption} state={state} />
        </div>
      </div>
    </div>
  );
};

ParagraphModule.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
  match: PropTypes.shape().isRequired,
};
ParagraphModule.defaultProps = {
  reusableComponent: null,
};

export default withRouter(ParagraphModule);
